
import { Component, Vue } from "nuxt-property-decorator";
import EsyImg from "~/components/atoms/embedding/EsyImg.vue";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import BreadCrumb from "~/components/molecules/display/BreadCrumb.vue";
import PelletsStickyComparisonBar from "~/components/organisms/display/pellets/PelletsStickyComparisonBar.vue";
import TransformNavigationMenu from "~/components/organisms/nav/TransformNavigationMenu.vue";
import { PelletContentPagesList } from "~/defaults/pellets/pelletsContentPages";
import { pelletsGuideCards } from "~/defaults/pellets/pelletsGuideCards";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import { PelletsGuideCard } from "~/types/Pellets";

@Component({
  components: {
    EsyImg,
    RouterLink,
    PelletsStickyComparisonBar,
    TransformNavigationMenu,
    BreadCrumb,
  },
})
export default class PelletGuide extends Vue {
  head() {
    if (!this.isOverview) return {};
    return {
      ...generateMetaTags(this.$route.path, "pellets-ratgeber"),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }

  PelletContentPagesList = PelletContentPagesList;
  guideCards: PelletsGuideCard[] = pelletsGuideCards;

  get isOverview(): boolean {
    return this.$route.path === "/pelletspreise/pellets-ratgeber";
  }

  get breadcrumbs() {
    const list = [
      {
        name: "Pelletspreise",
        linkUrl: "/pelletspreise",
      },
      {
        name: "Pellets Ratgeber",
        linkUrl: `/pelletspreise/pellets-ratgeber`,
      },
    ];

    if (!this.isOverview) {
      list.push({
        name: this.activeTabName,
        linkUrl: this.$route.path,
      });
    }

    return list;
  }

  get activeTabName(): string {
    const match = PelletContentPagesList.find(
      (ele) => this.$route.path === ele.link.path,
    );
    return match?.name ?? "";
  }
}
